import React from 'react';
import { Box, Container } from '@mui/material';
import { Chat } from '../../components/Chat';
import { useParams, useLocation } from 'react-router-dom';

export const ChatPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const location = useLocation();
  const initialMessage = location.state?.initialMessage;
  const initialAudioFile = location.state?.initialAudioFile;
  
  return (
    <Box sx={{ width: '100%', height: '100vh' }}>
      <Chat 
        sessionId={sessionId} 
        initialMessage={initialMessage}
        initialAudioFile={initialAudioFile}
      />
    </Box>
  );
};

export default ChatPage;